import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  /**
   * Get Item from localStorage
   * @param {string} key
   * @return {*}
   * @memberof StorageService
   */
  getItem(key: string) {
    const data = localStorage.getItem(key);
    const actualData = data ? JSON.parse(data) : null;
    return actualData;
  }

  /**
   * Set Item in localStorage
   * @param {string} key
   * @param {unknown} value
   * @memberof StorageService
   */
  setItem(key: string, value: unknown) {
    const data = JSON.stringify(value);
    localStorage.setItem(key, data);
  }

  /**
   * Remove item from localStorage
   * @param {string} key
   * @memberof StorageService
   */
  removeItem(key: string) {
    localStorage.removeItem(key);
  }

  /**
   * Clear localStorage
   * @memberof StorageService
   */
  clearStorage() {
    localStorage.clear();
  }
}
